import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {MergeBoxWithSuspense} from './MergeBox'
import {MergeBoxLayoutProvider} from '../contexts/MergeBoxLayoutContext'
import {useCurrentPullRequestTab} from '../hooks/use-current-pull-request-tab'
import type {Channels} from '../hooks/use-mergeability-live-updates'

interface MergeBoxPanelContentProps {
  helpUrl: string
  viewerLogin: string
  channels: Channels
}

/**
 * Shared content rendered inside both the MergeabilitySidesheet (Dialog) and
 * the MergeStatusSidePanel (docked panel). Keeps analytics metadata, layout
 * provider, and MergeBox rendering in sync between the two surfaces.
 */
export function MergeBoxPanelContent({helpUrl, viewerLogin, channels}: MergeBoxPanelContentProps) {
  const view = useCurrentPullRequestTab()
  const analyticsMetadata = {view, panel: 'true'}

  return (
    <MergeBoxLayoutProvider isSidePanel>
      <AnalyticsProvider appName="pull_request" category="mergebox_react_partial" metadata={analyticsMetadata}>
        <MergeBoxWithSuspense helpUrl={helpUrl} viewerLogin={viewerLogin} channels={channels} hideIcon />
      </AnalyticsProvider>
    </MergeBoxLayoutProvider>
  )
}
